import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const isNativeRuntime = () => {
  if (typeof window === "undefined") return false;

  const capacitorGlobal = window.Capacitor;
  if (capacitorGlobal && typeof capacitorGlobal.isNativePlatform === "function") {
    try {
      if (capacitorGlobal.isNativePlatform()) return true;
    } catch (_error) {
      // Ignore and continue with protocol fallback.
    }
  }

  const protocol = window.location?.protocol || "";
  return protocol === "capacitor:" || protocol === "ionic:";
};

export default function LandingRedirect() {
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      window.location.replace("/chat");
      return;
    }

    if (isNativeRuntime()) {
      window.location.replace("/auth/login");
      return;
    }

    // Use replaceState to update history without creating a new history entry
    // This prevents issues with browser back button
    window.history.replaceState(null, "", "/landing");
    
    // Check if we're already at /landing/index.html
    if (window.location.pathname === "/landing/" || window.location.pathname === "/landing/index.html") {
      return; // Already at landing, don't redirect
    }
    
    window.location.replace("/landing/index.html");
  }, [token]);

  return null;
}
